import type { Messages } from "@prop/i18n";
import type en from "../en/admin";

export default {
  title: "Administración",
  lead: "Operaciones del desk: personas, dinero, riesgo y la propia plataforma.",
  mfaGate: "El área de administración requiere verificación en dos pasos. Agrega un segundo factor en Seguridad y vuelve a iniciar sesión si se te pide.",
  toSecurity: "Abrir Seguridad",
  tabs: {
    users: "Usuarios",
    audit: "Registro de auditoría",
    settings: "Ajustes",
    jobs: "Tareas",
    errors: "Errores",
    data: "Estado de datos",
  },
  common: {
    search: "Buscar",
    reason: "Motivo (se guarda en el registro de auditoría)",
    save: "Guardar",
    cancel: "Cancelar",
    empty: "Aún no hay nada aquí",
    loadMore: "Cargar más",
    actions: "Acciones",
  },
  users: {
    searchPlaceholder: "Correo, nombre o @telegram",
    email: "Correo electrónico",
    telegramOnly: "Solo Telegram",
    name: "Nombre",
    roles: "Roles",
    status: "Estado",
    mfa: "2FA",
    lastLogin: "Último inicio de sesión",
    active: "Activo",
    blocked: "Bloqueado",
    block: "Bloquear",
    unblock: "Desbloquear",
    signOut: "Cerrar sesión en todas partes",
    editRoles: "Roles",
    rolesHint: "Requiere un superadmin con llave de seguridad. Se cierra la sesión del usuario para aplicar los nuevos roles.",
  },
  audit: {
    action: "Acción",
    actor: "Quién",
    target: "Objetivo",
    when: "Cuándo",
    reason: "Motivo",
    verify: "Verificar la cadena de hashes",
    chainOk: { one: "Cadena intacta: {count} registro verificado", other: "Cadena intacta: {count} registros verificados" },
    chainBroken: "Cadena rota en el registro {id}",
    filterAction: "La acción empieza con",
  },
  settings: {
    default: "predeterminado",
    changed: "Cambiado por {who}, {when}",
    saved: "Guardado",
  },
  jobs: {
    name: "Tarea",
    last: "Última ejecución",
    status: "Estado",
    lastOk: "Último éxito",
    failures: "Fallos 24 h",
    none: "Aún no hay ejecuciones: las tareas corren en el proceso worker.",
  },
  data: {
    instrument: "Instrumento",
    source: "Fuente",
    status: "Estado",
    book: "Libro",
    age: "Antigüedad de la cotización",
    lag: "Retraso",
    resyncs: "Resincronizaciones",
    adapters: "Fuentes",
    connected: "conectado",
    disconnected: "desconectado",
    reconnects: { one: "{count} reconexión", other: "{count} reconexiones" },
    live: "En vivo",
    closed: "Cerrado (fuera de sesión)",
    noData: "Sin datos",
    replay: "REPLAY",
    reasons: { syncing: "sincronizando", stale: "desactualizado", resyncing: "resincronizando", no_data: "sin fuente de datos" },
    unavailable: "md-gateway no responde.",
  },
  roles: {
    trader: "Trader",
    affiliate: "Afiliado",
    support: "Soporte",
    risk_analyst: "Analista de riesgo",
    risk_manager: "Gerente de riesgo",
    payments_operator: "Operador de pagos",
    payments_approver: "Aprobador de pagos",
    compliance: "Cumplimiento",
    product_admin: "Admin de producto",
    finance: "Finanzas",
    superadmin: "Superadmin",
  },
  settingKeys: {
    marketData_staleMsCrypto: "Límite de cotización desactualizada, cripto",
    marketData_staleMsFx: "Límite de cotización desactualizada, FX/CFD",
    marketData_staleMsFutures: "Límite de cotización desactualizada, futuros",
    payouts_newAddressDelayHours: "Espera de payout para una billetera nueva",
    payouts_reserveRatio: "Reserva de payouts por venta (parte del precio)",
    risk_breachReviewHours: "Plazo de revisión tras un incumplimiento",
    risk_fundingCapPerPersonUsd: "Capital funded por trader, todos los programas",
    payouts_cryptoAddressTtlMinutes: "Vigencia de la dirección de depósito cripto",
    payouts_checkoutTtlMinutes: "Vigencia del pago con tarjeta",
    payouts_cryptoConfirmations: "Confirmaciones cripto requeridas",
    payouts_underpayTolerancePct: "Tolerancia de pago cripto insuficiente",
    payouts_affiliateRatePct: "Comisión de afiliado predeterminada",
    payouts_withdrawalMinUsd: "Retiro mínimo del saldo",
    payouts_withdrawalFeeTronUsd: "Tarifa de red de retiro, TRON",
    payouts_withdrawalFeeEthereumUsd: "Tarifa de red de retiro, Ethereum",
    offers_bonusActivationPct: "Tarifa de activación del bono sin Turbo (parte del precio pagado)",
    offers_resetPricePct: "Reinicio tras un incumplimiento (parte del precio pagado)",
    offers_breachCouponPct: "Cupón tras un incumplimiento (descuento en la próxima compra)",
    offers_breachCouponDays: "Cupón tras un incumplimiento: días de validez",
    platform_demoBanner: "Banner de modo de prueba en cada página",
  },
  units: {
    ms: "ms",
    hours: "h",
  },
  errors: {
    message: "Error",
    count: "Cantidad",
    lastSeen: "Visto por última vez",
    resolve: "Marcar como corregido",
    showResolved: "Mostrar corregidos",
  },
} satisfies Messages<typeof en>;
